/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDeviceManagementApiKeyRequest } from '../models/CreateDeviceManagementApiKeyRequest';
import type { NuovopayDeviceSyncStatusCheckResponse } from '../models/NuovopayDeviceSyncStatusCheckResponse';
import type { PaginatedListDevicesResponse } from '../models/PaginatedListDevicesResponse';
import type { ViewMaskedDeviceManagementApiKeyResponse } from '../models/ViewMaskedDeviceManagementApiKeyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DeviceManagementService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns NuovopayDeviceSyncStatusCheckResponse OK
     * @throws ApiError
     */
    public checkExistingSyncJob({
        entityId,
        entityType,
    }: {
        entityId: string,
        entityType: 'SHOP' | 'FINANCIER',
    }): CancelablePromise<NuovopayDeviceSyncStatusCheckResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-management/sync',
            query: {
                'entityId': entityId,
                'entityType': entityType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public syncDevices({
        entityId,
        entityType,
    }: {
        entityId: string,
        entityType: 'SHOP' | 'FINANCIER',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/device-management/sync',
            query: {
                'entityId': entityId,
                'entityType': entityType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ViewMaskedDeviceManagementApiKeyResponse OK
     * @throws ApiError
     */
    public viewMaskedDeviceManagementApiKey({
        entityId,
        entityType,
    }: {
        entityId: string,
        entityType: 'SHOP' | 'FINANCIER',
    }): CancelablePromise<ViewMaskedDeviceManagementApiKeyResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-management/api-key',
            query: {
                'entityId': entityId,
                'entityType': entityType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public createDeviceManagementApiKey({
        requestBody,
    }: {
        requestBody: CreateDeviceManagementApiKeyRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/device-management/api-key',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteDeviceManagementApiKey({
        entityId,
        entityType,
    }: {
        entityId: string,
        entityType: 'SHOP' | 'FINANCIER',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/device-management/api-key',
            query: {
                'entityId': entityId,
                'entityType': entityType,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedListDevicesResponse OK
     * @throws ApiError
     */
    public listDevices({
        page,
        size,
        entityId,
        entityType,
        sortBy,
        status,
        startValidityDate,
        endValidityDate,
        startEnrolledOn,
        endEnrolledOn,
        online,
        locked,
        direction,
        search,
    }: {
        page: number,
        size: number,
        entityId: string,
        entityType: 'SHOP' | 'FINANCIER',
        sortBy?: string,
        status?: string,
        startValidityDate?: string,
        endValidityDate?: string,
        startEnrolledOn?: string,
        endEnrolledOn?: string,
        online?: boolean,
        locked?: boolean,
        direction?: string,
        search?: string,
    }): CancelablePromise<PaginatedListDevicesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/device-management',
            query: {
                'page': page,
                'size': size,
                'entityId': entityId,
                'entityType': entityType,
                'sortBy': sortBy,
                'status': status,
                'startValidityDate': startValidityDate,
                'endValidityDate': endValidityDate,
                'startEnrolledOn': startEnrolledOn,
                'endEnrolledOn': endEnrolledOn,
                'online': online,
                'locked': locked,
                'direction': direction,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
